import { ArrowUpRight, Droplet, Leaf, BookOpen, Shirt, Wallet, Moon } from "lucide-react";
import { goTo } from "@/lib/api";
import { Reveal, MaskLines, Eyebrow } from "./Reveal";

const RITUALS = [
  ["cycle", "Cycle", "Every phase, at the centre", Droplet],
  ["kitchen", "Nourish", "Meals for your body type", Leaf],
  ["pillars", "Faith", "A daily word from your tradition", BookOpen],
  ["style", "Style", "Outfits, colour, hair & beauty", Shirt],
  ["budget", "Money", "A budget that moves with you", Wallet],
  ["pillars", "Stars", "Your sign, woven into your day", Moon],
];

export const LifestyleIndex = () => (
  <section className="relative pb-4 pt-24 sm:pb-8 sm:pt-32" data-testid="lifestyle-index">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="grid gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-end">
        <div>
          <Reveal><Eyebrow>Cycle & lifestyle</Eyebrow></Reveal>
          <h2 className="mt-6 font-serif text-5xl font-light leading-[1] tracking-tight text-[#2C221E] sm:text-6xl lg:text-7xl">
            <MaskLines inView delay={0} lines={["Your cycle at the centre.", <em key="e" className="italic text-[#9E4429]">Your life around it.</em>]} />
          </h2>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-md text-base leading-relaxed text-[#5C4A42] sm:text-lg">
            Lunelle is a cycle and lifestyle app. Your cycle sits at the heart of it, and how you eat, pray, dress and spend flows from each phase.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-2 border-l border-t border-[#C86D51]/20 md:grid-cols-3 lg:grid-cols-6">
        {RITUALS.map(([id, name, line, Icon], i) => (
          <Reveal key={name} delay={i * 0.06} className="border-b border-r border-[#C86D51]/20">
            <a href={`#${id}`} onClick={(e) => { e.preventDefault(); goTo(id); }} data-testid={`lifestyle-ritual-${name.toLowerCase()}`}
              className="group relative flex h-full min-h-[200px] flex-col justify-between overflow-hidden p-5 transition-colors duration-500 hover:bg-[#2C221E] sm:p-6">
              <div className="flex items-start justify-between">
                <span className="text-xs font-semibold tracking-[0.2em] text-[#7A665C] transition-colors group-hover:text-[#E8B99A]">0{i + 1}</span>
                <ArrowUpRight className="h-4 w-4 text-[#9E4429] transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#E8B99A]" />
              </div>
              <div>
                <Icon className="h-6 w-6 text-[#9E4429] transition-colors group-hover:text-[#E8B99A]" />
                <p className="mt-4 font-serif text-3xl text-[#2C221E] transition-colors group-hover:text-[#FBF5EE]">{name}</p>
                <p className="mt-1 text-sm text-[#5C4A42] transition-colors group-hover:text-[#d9c7bd]">{line}</p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
